import Button from "../../realize_overrides/components/button/button";

export function TableCellRuleRender(value, rule, tableRowData) {
	if (typeof rule === 'object' && rule[value]) {
		let ruleOptions = rule[value];
		if (typeof ruleOptions === 'string') {
			return ruleOptions;
		} else if (typeof ruleOptions === 'function') {
			return ruleOptions({ value, tableRowData });
		}
	} else if (typeof rule === 'function') {
		return rule({ value, tableRowData });
	}
	return value;
}

export const TableCellRenderComponent = ({ configComponent, data }) => {
	let { type } = configComponent;
	switch(type) {
		case 'button':
			return <TableCellRenderButton config={configComponent.config} data={data}/>;
	}
}

//TODO: Passar os dados da linha
const TableCellRenderButton = ({ config, data }) => {
	return <Button
		id={config.name}
		icon={config.icon}
		onClick={config.onClick.bind(this, data)}
		element="button"
		role='button'
		themeClassKey="button.flat"
		className="table-cell__content"
	/>
}
